import { useCallback, useState } from 'react';

import FullScreenBanner from '@goshippo/libraries/shared/FullScreenBanner';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { OtcVerificationDialog } from '~/src/components/OtcVerificationDialog/OtcVerificationDialog';
import { useBillingAccount } from '~/src/hooks/useBillingAccount';
import { useGlobalAlerts } from '~/src/hooks/useGlobalAlerts';
import { useUserAccount } from '~/src/hooks/useUserAccount';

export const FullScreenBannerWrapper = () => {
  useGlobalAlerts();

  const { t } = useTranslation('', { keyPrefix: 'fullScreenBanner' });
  const navigate = useNavigate();
  const billingAccount = useBillingAccount().data;
  const { data, refetch } = useUserAccount();
  const [isOtcDialogOpen, setIsOtcDialogOpen] = useState(false);

  const handleGoToBilling = useCallback(() => {
    navigate('/account/billing');
  }, [navigate]);

  const isGracePeriodExpired = billingAccount?.grace_period_end_timestamp
    ? new Date(billingAccount.grace_period_end_timestamp) < new Date()
    : false;

  if (data?.requiresEmailVerification) {
    return (
      <>
        <FullScreenBanner
          actionFn={() => setIsOtcDialogOpen(true)}
          actionLabel={t('verifyEmail.actionLabel')}
          bannerType="notice"
          message={t('verifyEmail.message')}
        />
        <OtcVerificationDialog
          email={data.email}
          isOpen={isOtcDialogOpen}
          onClose={() => setIsOtcDialogOpen(false)}
          onSuccess={() => {
            setIsOtcDialogOpen(false);
            refetch();
          }}
        />
      </>
    );
  } else if (data?.hasFailedPayment || isGracePeriodExpired) {
    const message = isGracePeriodExpired
      ? `${t('pastDueInvoices.gracePeriod')} ${t('pastDueInvoices.message')}`
      : t('pastDueInvoices.message');

    return (
      <FullScreenBanner
        actionFn={handleGoToBilling}
        actionLabel={t('pastDueInvoices.actionLabel')}
        bannerType="notice"
        message={message}
      />
    );
  }
  return null;
};
